import { useRouteParams } from "@vueuse/router";
import { computed, toValue, watch, type MaybeRefOrGetter } from "vue";

import { CRouteParamsError } from "@/composables/use-route-params/route-params-error.types";
import { brandNumber, TBrand } from "@/utils/branded";

export function useBrandedNumberRouteParams<BRAND extends TBrand<number, unknown>>(
  routeParamName: string,
  options: { optional?: MaybeRefOrGetter<boolean>; defaultValue?: number } = { defaultValue: -1 },
) {
  const routeParam = useRouteParams(routeParamName, -1, { transform: Number });

  const brandedNumberRouteParam = computed<BRAND>(() => {
    return brandNumber<BRAND>(routeParam.value);
  });

  watch(
    brandedNumberRouteParam,
    (newRouteParam) => {
      if (!toValue(options.optional) && (newRouteParam < 0 || !isFinite(newRouteParam))) {
        throw new CRouteParamsError(routeParamName);
      }
    },
    { immediate: true },
  );

  return {
    brandedNumberRouteParam,
  };
}
